
import React from 'react'
import style from './OilRegister.module.css'
import oilStyle from '../Oil.module.css'
import { Translate } from '../../../language'
import { OilRegisterIcon } from '../../../assets/icons';
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import Input from '../../../utils/components/Input/Input';
import Button from '../../../utils/components/Button/Button'
import useModal from '../../../utils/hooks/useModal'


const OilRegister = ({ formik, liters, ecopoints, ecopointsValue, setEcopointsValue, isLoadingPostRegister }) => {

    const [ref, isShowModal, setIsShowModal] = useModal(false);

    const Modal = ({ presentation, displayModal, close, user, liters }) => {
        const registerOil = () => {
            formik.handleSubmit();
            close();
        }

        const divStyle = {
            display: displayModal ? 'block' : 'none'
        }
        if (!presentation) {
            return <></>
        }
        return (

            <div className={"modal"} style={divStyle}>
                <div className={style.register_modal}>
                    <p className={style.textRegisterModal}> ¿Desea registrar {liters} litros para el usuario {user}? </p>

                    <div className={["modal-content", style.button_modal_container]}>
                        <Button styles={{ width: "50%" }} onClick={() => { registerOil() }} text='Si' />
                        <Button styles={{ width: "50%" }} onClick={() => { close() }} text='No' />
                    </div>
                </div>
            </div>
        )
    }

    const onClickRegisterButton = () => {
        formik.validateForm().then((errors) => {
            if (Object.keys(errors).length ===0) {
                setIsShowModal(true);
            }
        })
    }

    const onQuantityValueChange = (event) => {
        formik.setFieldValue('quantity', (parseInt(event.target.value, 10)))
        setEcopointsValue((event.target.value) * ecopoints / liters);
    }

    const onClickSelect = (event) => {
        event.target.select();
    }

    return (

        <div className={style.container_form}>

            <TitleSVG Icon={OilRegisterIcon} titleHighlight={Translate('register', 'es')} title={Translate('oilRegisterTitle', 'es')} />

            <form className={style.container_oil_register} onSubmit={formik.handleSubmit} >

                <div className={style.form_content}>

                    <label htmlFor="email">{Translate('oilMailForm', 'es')}</label>

                    <Input
                        type="email"
                        placeholder={Translate('email', 'es')}
                        name="email"
                        value={formik.values.email}
                        classNameInput={style.form_input}
                        onChange={formik.handleChange} />

                </div>

                <div className={style.form_content_error}>
                    <div className={style.error}>{formik.errors.email}</div>
                </div>

                <div className={oilStyle.subtitle_container}>
                    <span className={oilStyle.subtitle_text}>
                        <span>{Translate('oilRegisterSubtitle1', 'es')} </span>
                        <span className={oilStyle.subtitle_text_highlight}>{Translate('oilRegisterSubtitle2', 'es')} </span>
                        <span>{Translate('oilRegisterSubtitle3', 'es')} </span>
                        <span className={oilStyle.subtitle_text_highlight}>{liters}{Translate('liters', 'es')} </span>
                        <span>{Translate('oilRegisterSubtitle5', 'es')} </span>
                        <span className={oilStyle.subtitle_text_highlight}>{ecopoints} {Translate('ecoPoints', 'es')} </span>
                    </span>
                </div>

                <div className={style.form_content}>

                    <div>{Translate('oilReceivedForm', 'es')}</div>

                    <Input placeholder={Translate('quantity', 'es')}
                        type='number'
                        min={liters}
                        name='quantity'
                        value={formik.values.quantity}
                        classNameInput={style.form_input}
                        onChange={onQuantityValueChange}
                        onClick={onClickSelect} />

                </div>

                <div className={style.form_content_error}>
                    <div className={style.error}>{formik.errors.quantity}</div>
                </div>

                <div className={oilStyle.subtitle_container}>
                    <span className={oilStyle.subtitle_text}>
                        {Translate('oilEcopointsSubtitle', 'es')}
                    </span>
                </div>
                <div className={style.center_items}>
                    <div className={style.box_ecopoints_container}>
                        <span className={style.box_ecopoints_text}>
                            {ecopointsValue}
                        </span>
                    </div>

                    <Button
                        onClick={() => onClickRegisterButton()}
                        theme="white" text={Translate('registerText', 'es')}
                        disable={isLoadingPostRegister}
                        classNameContent={style.button_register}
                    >
                    </Button>
                </div>
            </form>
            <Modal
                presentation={{}}
                displayModal={isShowModal}
                close={() => setIsShowModal(false)}
                user={formik.values.email}
                liters={formik.values.quantity}
            />

        </div>
    )
}



export default OilRegister